import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

//import { getParties } from './party';


export const LOADING_DEVICES = () => ({ type: 'LOADING_DEVICES', });
export const LOADING_DEVICES_SUCCESS = () => ({ type: 'LOADING_DEVICES_SUCCESS', });
export const LOADING_DEVICES_ERROR = () => ({ type: 'LOADING_DEVICES_ERROR', });

export const ADDING_DEVICE = () => ({ type: 'ADDING_DEVICE', });
export const ADDING_DEVICE_SUCCESS = () => ({ type: 'ADDING_DEVICE_SUCCESS', });
export const ADDING_DEVICE_ERROR = () => ({ type: 'ADDING_DEVICE_ERROR', });

export const UPDATING_DEVICE = () => ({ type: 'UPDATING_DEVICE', });
export const UPDATING_DEVICE_SUCCESS = () => ({ type: 'UPDATING_DEVICE_SUCCESS', });
export const UPDATING_DEVICE_ERROR = () => ({ type: 'UPDATING_DEVICE_ERROR', });

export const DELETING_DEVICE = () => ({ type: 'DELETING_DEVICE', });
export const DELETING_DEVICE_SUCCESS = () => ({ type: 'DELETING_DEVICE_SUCCESS', });
export const DELETING_DEVICE_ERROR = () => ({ type: 'DELETING_DEVICE_ERROR', });

export const FINDING_DEVICES = () => ({ type: 'FINDING_DEVICES', });
export const FINDING_DEVICES_SUCCESS = () => ({ type: 'FINDING_DEVICES_SUCCESS', });
export const FINDING_DEVICES_ERROR = () => ({ type: 'FINDING_DEVICES_ERROR', });

export const FINDING_DEVICE_LOGS = () => ({ type: 'FINDING_DEVICE_LOGS', });
export const FINDING_DEVICE_LOGS_SUCCESS = () => ({ type: 'FINDING_DEVICE_LOGS_SUCCESS', });
export const FINDING_DEVICE_LOGS_ERROR = () => ({ type: 'FINDING_DEVICE_LOGS_ERROR', });

export const DELETING_DEVICE_LOGS = () => ({ type: 'DELETING_DEVICE_LOGS', });
export const DELETING_DEVICE_LOGS_SUCCESS = () => ({ type: 'DELETING_DEVICE_LOGS_SUCCESS', });
export const DELETING_DEVICE_LOGS_ERROR = () => ({ type: 'DELETING_DEVICE_LOGS_ERROR', });

export const FINDING_DEVICE_ERRORS = () => ({ type: 'FINDING_DEVICE_ERRORS', });
export const FINDING_DEVICE_ERRORS_SUCCESS = () => ({ type: 'FINDING_DEVICE_ERRORS_SUCCESS', });
export const FINDING_DEVICE_ERRORS_ERROR = () => ({ type: 'FINDING_DEVICE_ERRORS_ERROR', });

export const DELETING_DEVICE_ERRORS = () => ({ type: 'DELETING_DEVICE_ERRORS', });
export const DELETING_DEVICE_ERRORS_SUCCESS = () => ({ type: 'DELETING_DEVICE_ERRORS_SUCCESS', });
export const DELETING_DEVICE_ERRORS_ERROR = () => ({ type: 'DELETING_DEVICE_ERRORS_ERROR', });

export const FINDING_DEVICE_HISTORIES = () => ({ type: 'FINDING_DEVICE_HISTORIES', });
export const FINDING_DEVICE_HISTORIES_SUCCESS = () => ({ type: 'FINDING_DEVICE_HISTORIES_SUCCESS', });
export const FINDING_DEVICE_HISTORIES_ERROR = () => ({ type: 'FINDING_DEVICE_HISTORIES_ERROR', });

export const DELETING_DEVICE_HISTORIES = () => ({ type: 'DELETING_DEVICE_HISTORIES', });
export const DELETING_DEVICE_HISTORIES_SUCCESS = () => ({ type: 'DELETING_DEVICE_HISTORIES_SUCCESS', });
export const DELETING_DEVICE_HISTORIES_ERROR = () => ({ type: 'DELETING_DEVICE_HISTORIES_ERROR', });

export const LOADING_MODEMS = () => ({ type: 'LOADING_MODEMS', });
export const LOADING_MODEMS_SUCCESS = () => ({ type: 'LOADING_MODEMS_SUCCESS', });
export const LOADING_MODEMS_ERROR = () => ({ type: 'LOADING_MODEMS_ERROR', });

export const ADDING_MODEM = () => ({ type: 'ADDING_MODEM', });
export const ADDING_MODEM_SUCCESS = () => ({ type: 'ADDING_MODEM_SUCCESS', });
export const ADDING_MODEM_ERROR = () => ({ type: 'ADDING_MODEM_ERROR', });

export const UPDATING_MODEM = () => ({ type: 'UPDATING_MODEM', });
export const UPDATING_MODEM_SUCCESS = () => ({ type: 'UPDATING_MODEM_SUCCESS', });
export const UPDATING_MODEM_ERROR = () => ({ type: 'UPDATING_MODEM_ERROR', });

export const DELETING_MODEM = () => ({ type: 'DELETING_MODEM', });
export const DELETING_MODEM_SUCCESS = () => ({ type: 'DELETING_MODEM_SUCCESS', });
export const DELETING_MODEM_ERROR = () => ({ type: 'DELETING_MODEM_ERROR', });

export const FINDING_MODEMS = () => ({ type: 'FINDING_MODEMS', });
export const FINDING_MODEMS_SUCCESS = () => ({ type: 'FINDING_MODEMS_SUCCESS', });
export const FINDING_MODEMS_ERROR = () => ({ type: 'FINDING_MODEMS_ERROR', });

export const FINDING_MODEM_HISTORIES = () => ({ type: 'FINDING_MODEM_HISTORIES', });
export const FINDING_MODEM_HISTORIES_SUCCESS = () => ({ type: 'FINDING_MODEM_HISTORIES_SUCCESS', });
export const FINDING_MODEM_HISTORIES_ERROR = () => ({ type: 'FINDING_MODEM_HISTORIES_ERROR', });

export const DELETING_MODEM_HISTORIES = () => ({ type: 'DELETING_MODEM_HISTORIES', });
export const DELETING_MODEM_HISTORIES_SUCCESS = () => ({ type: 'DELETING_MODEM_HISTORIES_SUCCESS', });
export const DELETING_MODEM_HISTORIES_ERROR = () => ({ type: 'DELETING_MODEM_HISTORIES_ERROR', });


export const getDevices = (dispatch) => {
  dispatch({ type: LOADING_DEVICES });

  axios
    .get(`${serverURI}/api/device/all`)
    .then((res) => {
      dispatch({
        type: LOADING_DEVICES_SUCCESS,
        payload: res.data.devices
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_DEVICES_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addDevice = (device, dispatch) => {
  dispatch({ type: ADDING_DEVICE });

  axios
    .post(`${serverURI}/api/device/add`, device)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_DEVICE_SUCCESS, 
        payload: res.data.device, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_DEVICE_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateDevice = (id, device, dispatch) => {
  dispatch({ type: UPDATING_DEVICE });

  axios
    .put(`${serverURI}/api/device/update/${id}`, device)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_DEVICE_SUCCESS, 
        payload: res.data.device, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_DEVICE_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteDevice = (deletes, dispatch) => {
  dispatch({ type: DELETING_DEVICE });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/device/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_DEVICE_SUCCESS, 
        payload: res.data.deletedDevices, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_DEVICE_ERROR, payload: err });
      errorHandler(err);
    });
};


export const findDevices = (find, dispatch) => {
  dispatch({ type: FINDING_DEVICES });

  axios
    .post(`${serverURI}/api/device/find/device`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_DEVICES_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_devices: res.data.devices, 
        }
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_DEVICES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeDevices = (dispatch) => {
  dispatch({ type: FINDING_DEVICES_SUCCESS, 
    payload: {
      find_total: 0,
      find_devices: [], 
    }
  });
};


export const findDeviceLogs = (find, dispatch) => {
  dispatch({ type: FINDING_DEVICE_LOGS });

  axios
    .post(`${serverURI}/api/device/log/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_DEVICE_LOGS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_logs: res.data.logs, 
        }, 
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_DEVICE_LOGS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeDeviceLogs = (dispatch) => {
  dispatch({ type: FINDING_DEVICE_LOGS_SUCCESS, 
    payload: {
      find_total: 0,
      find_logs: [], 
    }, 
  });
};


export const deleteDeviceLogs = (deleteDate, dispatch) => {
  dispatch({ type: DELETING_DEVICE_LOGS });

  const deleteData = {
    deleteDate: deleteDate,
  };

  return axios
    .delete(`${serverURI}/api/device/log/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_DEVICE_LOGS_SUCCESS, 
        payload: [], 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_DEVICE_ERROR, payload: err });
      errorHandler(err);
    });
};




export const findDeviceErrors = (find, dispatch) => {
  dispatch({ type: FINDING_DEVICE_ERRORS });

  axios
    .post(`${serverURI}/api/device/error/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_DEVICE_ERRORS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_errors: res.data.errors, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_DEVICE_ERRORS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeDeviceErrors = (dispatch) => {
  dispatch({ type: FINDING_DEVICE_ERRORS_SUCCESS, 
    payload: {
      find_total: 0,
      find_errors: [], 
    },
  });
};


export const deleteDeviceErrors = (deleteDate, dispatch) => {
  dispatch({ type: DELETING_DEVICE_ERRORS });

  const deleteData = {
    deleteDate: deleteDate,
  };

  return axios
    .delete(`${serverURI}/api/device/error/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_DEVICE_ERRORS_SUCCESS, 
        payload: [], 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_DEVICE_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findDeviceHistories = (find, dispatch) => {
  dispatch({ type: FINDING_DEVICE_HISTORIES });

  axios
    .post(`${serverURI}/api/device/history/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_DEVICE_HISTORIES_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_histories: res.data.histories, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_DEVICE_HISTORIES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeDeviceHistories = (dispatch) => {
  dispatch({ type: FINDING_DEVICE_HISTORIES_SUCCESS, 
    payload: {
      find_total: 0,
      find_histories: [], 
    },
  });
};

export const deleteDeviceHistories = (deleteDate, dispatch) => {
  dispatch({ type: DELETING_DEVICE_HISTORIES });

  const deleteData = {
    deleteDate: deleteDate,
  };

  return axios
    .delete(`${serverURI}/api/device/history/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_DEVICE_HISTORIES_SUCCESS, 
        payload: [], 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_DEVICE_HISTORIES, payload: err });
      errorHandler(err);
    });
};






export const getModems = (dispatch) => {
  dispatch({ type: LOADING_DEVICES });

  axios
    .get(`${serverURI}/api/modem/all`)
    .then((res) => {
      dispatch({
        type: LOADING_MODEMS_SUCCESS,
        payload: res.data.modems
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_MODEMS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addModem = (modem, dispatch) => {
  dispatch({ type: ADDING_MODEM });

  axios
    .post(`${serverURI}/api/modem/add`, modem)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_MODEM_SUCCESS, 
        payload: res.data.modem, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_MODEM_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateModem = (id, modem, dispatch) => {
  dispatch({ type: UPDATING_MODEM });

  axios
    .put(`${serverURI}/api/modem/update/${id}`, modem)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_MODEM_SUCCESS, 
        payload: res.data.modem, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_MODEM_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteModem = (deletes, dispatch) => {
  dispatch({ type: DELETING_MODEM });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/modem/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_MODEM_SUCCESS, 
        payload: res.data.deletedModems, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_MODEM_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findModems = (find, dispatch) => {
  dispatch({ type: FINDING_MODEMS });

  axios
    .post(`${serverURI}/api/modem/find/modem`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_MODEMS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_modems: res.data.modems, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_MODEMS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeModems = (dispatch) => {
  dispatch({ type: FINDING_MODEMS_SUCCESS, 
    payload: {
      find_total: 0,
      find_modems: [], 
    },
  });
};

export const findModemHistories = (find, dispatch) => {
  dispatch({ type: FINDING_MODEM_HISTORIES });

  axios
    .post(`${serverURI}/api/modem/history/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_MODEM_HISTORIES_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_mhistories: res.data.mhistories, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_MODEM_HISTORIES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeModemHistories = (dispatch) => {
  dispatch({ type: FINDING_MODEM_HISTORIES_SUCCESS, 
    payload: {
      find_total: 0,
      find_mhistories: [], 
    },
  });
};


export const deleteModemHistories = (deleteDate, dispatch) => {
  dispatch({ type: DELETING_MODEM_HISTORIES });

  const deleteData = {
    deleteDate: deleteDate,
  };

  return axios
    .delete(`${serverURI}/api/modem/history/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_MODEM_HISTORIES_SUCCESS, 
        payload: [], 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_MODEM_HISTORIES, payload: err });
      errorHandler(err);
    });
};